import { mapActions } from "vuex";
export const verticalMixin = {
  data() {
    return {
      phaseOption: [],
      ownerOptions: [],
    }
  },
  methods: {
    ...mapActions([
      "fetchStockMaterialsList",
    ]),
    getFloorIndex(floorUuid, groundFloors, undergroundFloors){
      let index;
      let founded = false;
      groundFloors.forEach(floor =>{
        if(floor.uuid === floorUuid){
          index = floor.index;
          founded = true;
        }
      });
      if(!founded){
        undergroundFloors.forEach(floor =>{
          if(floor.uuid === floorUuid){
            index = floor.index;
          }
        });
      }
      return index;
    },
    getColumnIndex(column_uuid, columns){
      let index;
      columns.forEach(column =>{
        if(column.uuid === column_uuid){
          index = column.index
        }
      });
      return index;
    },
    getOwnerOption(){
      const owners  = this.$store.getters.getListOfOptionsByListName(
        "list_organization",
        [],
        true
      );
      owners.forEach((owner)=>{
        this.ownerOptions.push(
          {
            id: owner.or_id,
            label: owner.libelle
          }
        )
      });
    },
    getPhaseOption(){
      const projectPhases = this.$store.getters.optionLists_phase;
      projectPhases.forEach((phase)=>{
        this.phaseOption.push({
              label: phase.client_label ? phase.client_label : phase.libelle,
              id: phase.code
          });
      });
    },
  }
}


// WEBPACK FOOTER //
// ./src/mixins/verticalMixin.js